export default "__VITE_ASSET__CG4gJQ0U__"